<template>
  <div :class="[$style.container]" @click="toggleDropdown">
    <!-- <transition name="dropdown"> -->
    <div v-if="open" :class="$style.dropdownContent">
      <div
        v-for="(item, index) in items"
        :key="item.id"
        :class="[
          $style.listItem,
          isActive.id === item.id && $style.active,
          hoverState.id === item.id && $style.hover,
          index === items.length && $style.listItemLast
        ]"
        @click="selectItem(item)"
        @mouseover="handleMouseOver(item)"
        @mouseout="handleMouseOut(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { type DropdownItem } from '../types'

export interface Selected {
  id?: number
  active: boolean
}

export default defineComponent({
  name: 'DropDownSettings',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array as () => DropdownItem[],
      required: true
    }
  },
  emits: ['activate', 'deactivate'],
  setup(props, { emit }) {
    const notSelected: Selected = {
      id: undefined,
      active: false
    }
    const hovered: Selected = {
      id: undefined,
      active: false
    }
    const isActive = ref(notSelected)
    const hoverState = ref(hovered)
    const isOpen = ref(false)

    const toggleDropdown = () => {
      isOpen.value = !isOpen.value
    }

    const handleMouseOver = (item: { id: number; label: string }) => {
      let hovered: Selected = {
        id: item.id,
        active: true
      }
      hoverState.value = hovered
    }

    const handleMouseOut = (item: { id: number; label: string }) => {
      let hovered: Selected = {
        id: item.id,
        active: false
      }
      hoverState.value = hovered
    }
    const selectItem = (item: { id: number; label: string }) => {
      toggleDropdown
      let selected: Selected = {
        id: item.id,
        active: true
      }
      isActive.value = selected
      emit('activate', selected.id)
    }

    return {
      hoverState,
      isActive,
      isOpen,
      toggleDropdown,
      selectItem,
      handleMouseOver,
      handleMouseOut
    }
  }
})
</script>

<style module>
.container {
  position: absolute;
  width: 15%;
  right: 90px;
  top: 50px;
  background-color: green;
  border: 2px solid #000;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* padding: 11px 16px; */
  /* gap: 8px; */
  font-family: 'Antarlida', sans-serif;
  font-size: 16px;
  line-height: 110%;
  letter-spacing: -0.02em;
  color: #000;
  transition: all 0.3s ease;
}

.dropdownContent {
  position: absolute;
  margin-top: 2px;
  top: 100%;
  left: -2px;
  width: calc(100% + 4px);
  z-index: 1;
  display: block;
  transition: opacity 0.3s ease-out;
  box-sizing: border-box;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.3s ease-out;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
}

.icon {
  transition: transform 0.3s;
}

.rotateIcon {
  transform: rotate(180deg);
}

.property1selected {
  position: relative;
  background-color: #f4f4f4;
  border-bottom: 1px solid #000;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 13px 16px;
  text-align: left;
  font-size: 16px;
  color: #000;
  font-family: Antarlida;
}
.active {
  background-color: #f4f4f4;
}
.content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.text {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.listItem {
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #000;
  border-left: 2px solid #000;
  border-right: 2px solid #000;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 13px 18px;
  text-align: left;
  font-size: 16px;
  color: #000;
  font-family: Antarlida;
  z-index: 1;
}

.listItemLast {
  border-bottom: 2px solid #000;
}

.hover {
  background-color: var(--app-yellow);
}
.active {
  background-color: #f4f4f4;
}
</style>
